import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'
import { UserChat } from './types'

export const FETCH_USER_CHATS = 'userchat/FETCH_USER_CHATS'
export const FETCH_USER_CHATS_SUCCESS = 'userchat/FETCH_USER_CHATS_SUCCESS'

export const UserChatActions = {
  fetchUserChats: (limit: number, offset: number) => createAction(FETCH_USER_CHATS, { limit, offset }),
  fetchUserChatsSuccess: (data: { data: UserChat[]; count: number }) => createAction(FETCH_USER_CHATS_SUCCESS, data)
}

export type UserChatActions = ActionsUnion<typeof UserChatActions>
